import React from 'react';
import { useExternalData } from '../../contexts/external-data-context';
import { useFormFields } from '../../contexts/form-fields-context';
import { type ReadOnlyField as ReadOnlyFieldEntity } from '../../types';
import { type FieldLayoutComponent } from '../../../../field-layout';
import { useForm } from '../../../../contexts/form-context';
import { FieldPropsContext } from '../../../../contexts/field-props-context';
import { FIELD_PROPS_MAPPERS } from '../../../../mappers/public-props-map';

export interface ReadOnlyFieldProps {
  field: ReadOnlyFieldEntity;
  FieldLayout: FieldLayoutComponent;
}

export const ReadOnlyField = ({ field, FieldLayout }: ReadOnlyFieldProps) => {
  const componentsById = useFormFields();
  const externalData = useExternalData();
  const form = useForm();

  const { requiredIndicator, requiredIndicatorPlacement } =
    form.requiredIndicatorProperties || {};
  const propsMapper = FIELD_PROPS_MAPPERS[field.fieldType];

  const FieldComponent = componentsById[field.fieldType];

  if (!FieldComponent) {
    return null;
  }

  return (
    <FieldPropsContext.Provider
      value={{
        ...propsMapper({
          ...field.properties,
          id: field.id,
          externalData,
          fieldType: field.fieldType,
          requiredIndicatorType: requiredIndicator,
          requiredIndicatorPlacement,
        }),
      }}
    >
      <FieldComponent
        {...field.properties}
        id={field.id}
        externalData={externalData}
        fieldType={field.fieldType}
        FieldLayout={FieldLayout}
        requiredIndicatorType={requiredIndicator}
        requiredIndicatorPlacement={requiredIndicatorPlacement}
      />
    </FieldPropsContext.Provider>
  );
};
